"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.renderThumbVerticalDefault = exports.renderThumbHorizontalDefault = exports.renderTrackVerticalDefault = exports.renderTrackHorizontalDefault = exports.renderViewDefault = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
function renderViewDefault(props) {
    return jsx_runtime_1.jsx("div", __assign({}, props), void 0);
}
exports.renderViewDefault = renderViewDefault;
function renderTrackHorizontalDefault(_a) {
    var style = _a.style, props = __rest(_a, ["style"]);
    var finalStyle = __assign(__assign({}, style), { right: 2, bottom: 2, left: 2, borderRadius: 3, zIndex: 100 });
    return jsx_runtime_1.jsx("div", __assign({ style: finalStyle }, props), void 0);
}
exports.renderTrackHorizontalDefault = renderTrackHorizontalDefault;
function renderTrackVerticalDefault(_a) {
    var style = _a.style, props = __rest(_a, ["style"]);
    var finalStyle = __assign(__assign({}, style), { right: 2, bottom: 2, top: 2, borderRadius: 3, zIndex: 100 });
    return jsx_runtime_1.jsx("div", __assign({ style: finalStyle }, props), void 0);
}
exports.renderTrackVerticalDefault = renderTrackVerticalDefault;
function renderThumbHorizontalDefault(_a) {
    var style = _a.style, props = __rest(_a, ["style"]);
    var finalStyle = __assign(__assign({}, style), { cursor: 'pointer', borderRadius: 'inherit', backgroundColor: 'rgba(0,0,0,.2)' });
    return jsx_runtime_1.jsx("div", __assign({ style: finalStyle }, props), void 0);
}
exports.renderThumbHorizontalDefault = renderThumbHorizontalDefault;
function renderThumbVerticalDefault(_a) {
    var style = _a.style, props = __rest(_a, ["style"]);
    var finalStyle = __assign(__assign({}, style), { cursor: 'pointer', borderRadius: 'inherit', backgroundColor: 'rgba(0,0,0,.2)' });
    return jsx_runtime_1.jsx("div", __assign({ style: finalStyle }, props), void 0);
}
exports.renderThumbVerticalDefault = renderThumbVerticalDefault;
